/* eslint-disable curly */
import React, { Component, useState, useRef } from "react";
import {
  View,
  Text,
  ImageBackground,
  KeyboardAvoidingView,
  Platform,
  StatusBar,
  ScrollView,
} from "react-native";

import { getStatusPorCpf } from "../../../services/aluno-service";
import ButtonConfirm from "../../../components/ButtonConfirm";
import Loading from "../../../components/Loading";
import styles from "./styles";
import { TextInputMask } from "react-native-masked-text";
import { api } from "../../../services/api";
import { alert } from "../../../utils/alerts";

const ResetSenhaCpf = ({ navigation }) => {
  const [loading, setLoading] = useState(false);

  const inputCpf = useRef();

  const enviar = async (e) => {
    setLoading(true);
    let aluno = navigation.getParam("aluno");

    try {
      const retorno = await api.post(`/alunos/${aluno.cpf}/reset-senha`);

      setLoading(false);

      aluno = { ...aluno, ...retorno.data };

      navigation.replace("ResetSenhaSMS", { aluno });
    } catch (e) {
      setLoading(false);
      if (e.response) {
        return alert("Erro", e.response.data.erro);
      }
      console.log(e);
      alert(
        "Erro",
        "Houve um erro no servidor, tente novamente mais tarde"
      );
    }
  };

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.OS === "ios" ? "padding" : "null"}
        enabled
      >
        <ImageBackground
          source={require("../../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={styles.containerForm}>
            <ScrollView>
              <Text style={styles.textHeader1}>
                ESQUECEU A SENHA? SEM PROBLEMAS
              </Text>
              <Text style={styles.textHeader1}>VAMOS REDEFINI-LA</Text>
              <Text style={styles.textHeader2}>
                MAS ANTES ENVIAREMOS UM CÓDIGO PARA O SEU CELULAR
              </Text>
            </ScrollView>
          </View>
          <ButtonConfirm
            text="Enviar código"
            disabled={false}
            onPress={enviar}
            msgDisabled=""
          />
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
};

export default ResetSenhaCpf;
